import { render } from "./HospitalScreenChart.vue?vue&type=template&id=24e8b00a&scoped=true"
import script from "./HospitalScreenChart.vue?vue&type=script&lang=js"
export * from "./HospitalScreenChart.vue?vue&type=script&lang=js"

import "./HospitalScreenChart.vue?vue&type=style&index=0&id=24e8b00a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e8b00a"]])

export default __exports__